import { MainHeaderSharedHelper } from './cc-main-header-shared-helper.js';

class MainMobileHeader extends MainHeaderSharedHelper {
    constructor() {
        super();

        this.announcementBar = document.querySelector('.announcement-bar-section');
        this.tabletMediaQuery = window.matchMedia('(max-width: 1024px)');
        this.mobileMenuModal = this.querySelector('[data-modal]');
    }

    connectedCallback() {
        super.connectedCallback();

        this.tabletMediaQuery.addEventListener('change', (event) => {
            if (event.matches) {
                this.repositionAnnouncementBarMobile();
            } else {
                this.removeAnnouncementBarMobile();
            }
        });

        if (this.tabletMediaQuery.matches) {
            this.repositionAnnouncementBarMobile();
        } else {
            this.removeAnnouncementBarMobile();
        }

        this.addEventListener('click', (event) => {
            this.openModal(event);
            this.closeModal(event);
        });
    }

    repositionAnnouncementBarMobile() {
        if (this.announcementBar) {
            const cloned = this.announcementBar.cloneNode(true);
            this.appendChild(cloned);
            this.querySelector('.announcement-bar-section').classList.add('is-active');
        }
    }

    removeAnnouncementBarMobile() {
        if (this.querySelector('.announcement-bar-section')) {
            this.querySelector('.announcement-bar-section').remove();
        }
    }

    openModal(event) {
        if (event.target.getAttribute('data-open-modal') && this.mobileMenuModal.getAttribute('data-modal') == 'main-mobile-header-modal') {
            this.mobileMenuModal.classList.add('is-active');
            document.body.classList.add('scroll-lock');
        }
    }

    closeModal(event) {
        if (event.target.getAttribute('data-close-modal') && this.mobileMenuModal.getAttribute('data-modal') == 'main-mobile-header-modal') {
            this.mobileMenuModal.classList.remove('is-active');
            document.body.classList.remove('scroll-lock');
        }
    }
}

if (!customElements.get('main-mobile-header')) {
    customElements.define('main-mobile-header', MainMobileHeader);
}
